// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    padding: 0;
    margin: 0;
    background-color: black;
    overflow: hidden;
}


#copyright {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: black;
    line-height: 12px;
    padding: 4px;
    z-index: 9;
    font-family: Roboto;
    font-style: normal;
    font-size: 0.8em;
    letter-spacing: 0.0575em;
    color: white;

}

#logo {
    position: absolute;
    bottom: 16px;
    left: 16px;
    height: 24px;
    display: inline-block;
}

#deck-wrapper {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;;AAEhB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB","sourcesContent":["body {\n    padding: 0;\n    margin: 0;\n    background-color: black;\n    overflow: hidden;\n}\n\n\n#copyright {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    background-color: black;\n    line-height: 12px;\n    padding: 4px;\n    z-index: 9;\n    font-family: Roboto;\n    font-style: normal;\n    font-size: 0.8em;\n    letter-spacing: 0.0575em;\n    color: white;\n\n}\n\n#logo {\n    position: absolute;\n    bottom: 16px;\n    left: 16px;\n    height: 24px;\n    display: inline-block;\n}\n\n#deck-wrapper {\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
